<template>
  <div class="container">
    <div class="content-home-title">Whoops, no data for this page!</div>
    <div class="content-subtitle">
      While you’re here, why not check out our
      <a href="/">home page</a>
    </div>
  </div>
</template>

<script>
export default {
  name: "NoData",
};
</script>
<style lang="scss" scoped>
.container {
  align-items: center;
  display: flex;
  flex-direction: column;
  height: 100vh;
  margin-top: 3rem;
  margin-left: auto;
  margin-right: auto;
  width: 60rem;
}
.content-home-title {
  font-weight: 700;
  font-size: 2rem;
  margin-bottom: 1rem;
}
.content-subtitle {
  font-size: 1.2rem;
  font-weight: 400;
  line-height: 32px;
}
</style>
